import React, { FC } from 'react'
import { TextFieldStyled } from './TextField.styles'

interface TextFieldProps {
  placeholder: string
  value: string
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
  onEnter: () => void
}

export const TextField: FC<TextFieldProps> = ({ onEnter, ...props }) => {
  const textFieldRef = React.useRef<HTMLInputElement>(null)
  React.useEffect(() => {
    textFieldRef?.current?.focus()
  }, [])

  return (
    <TextFieldStyled
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          onEnter()
        }
      }}
      ref={textFieldRef}
      {...props}
    />
  )
}

export default TextField
